<template>
  <div class="container-info-window">
    <span v-show="feature.fill_level > 0" class="fill-level" :class="fillLevelColor">{{ feature.fill_level }}%</span>
    <h3>
      <a :href="`/containers/${feature.uuid}`">{{ feature.name }}</a>
    </h3>
    <p>
      <span class="material-icons">gps_fixed</span>
      <span>{{ feature.location }}</span>
    </p>
    <p v-if="feature.measured_at_formatted || feature.measured_at">
      <span class="material-icons">schedule</span>
      <span>{{ feature.measured_at_formatted || feature.measured_at }}</span>
    </p>
    <p class="show-details">
      <a :href="`/containers/${feature.uuid}`">{{ showDetails }} ›</a>
    </p>
  </div>
</template>

<script>
export default {
  name: 'MapPopup',
  props: {
    fillLevelColor: { type: String, default: '' },
    feature: { type: Object, required: true },
    showDetails: { type: String, default: 'Show Details:' },
  },
}
</script>
